function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
import { MetadataOptionService } from './service/MetadataOptionService';
import { MetadataSearchService } from './service/MetadataSearchService';
import { METADATA_BUNDLE_LOCALIZATION_ID } from './instance';
import { CoverageHelper } from '../../mapping/mapmodule/plugin/layers/coveragetool/CoverageHelper';
var MetadataStateHandler = /*#__PURE__*/function (_StateHandler) {
  function MetadataStateHandler(instance) {
    var _this;
    _classCallCheck(this, MetadataStateHandler);
    _this = _callSuper(this, MetadataStateHandler);
    _this.instance = instance;
    _this.optionsService = new MetadataOptionService(_this.instance.optionAjaxUrl);
    _this.searchService = new MetadataSearchService(_this.instance.searchAjaxUrl);
    _this.mapLayerService = _this.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
    _this.coverageHelper = new CoverageHelper();
    _this.coverageHelper.initCoverageToolPlugin();
    _this.setState({
      query: '',
      advancedSearchExpanded: false,
      advancedSearchOptions: null,
      advancedSearchValues: {},
      loading: false,
      drawing: false,
      searchResultsVisible: false,
      searchResultsFilter: null,
      coverageFeature: null,
      selectedLayers: null
    });
    return _this;
  }
  _inherits(MetadataStateHandler, _StateHandler);
  return _createClass(MetadataStateHandler, [{
    key: "getSandbox",
    value: function getSandbox() {
      return this.instance.getSandbox();
    }
  }, {
    key: "getVectorLayerId",
    value: function getVectorLayerId() {
      return this.instance.getVectorLayerId();
    }
  }, {
    key: "updateQuery",
    value: function updateQuery(query) {
      this.updateState({
        query: query
      });
    }
  }, {
    key: "handleMetadataSearchRequest",
    value: function handleMetadataSearchRequest(formdata, successCallback) {
      return this.searchService.doSearch(formdata, successCallback);
    }
  }, {
    key: "doSearch",
    value: function doSearch() {
      var _this2 = this;
      var _this$getState = this.getState(),
        _this$getState$query = _this$getState.query,
        query = _this$getState$query === void 0 ? '' : _this$getState$query,
        advancedSearchValues = _this$getState.advancedSearchValues;
      var search = query.trim();
      var params = search ? {
        search: search
      } : {};
      Object.keys(advancedSearchValues).forEach(function (key) {
        var value = advancedSearchValues[key];
        if (Array.isArray(value)) {
          value = value.join(',');
        }
        // eliminate nulls and empty values
        if (value) {
          params[key] = value;
        }
      });
      if (!Object.keys(params).length) {
        return;
      }
      this.updateState({
        loading: true,
        searchResultsVisible: false,
        searchResultsFilter: null
      });
      this.searchService.doSearch(params, function (results) {
        return _this2.updateSearchResults(results);
      });
    }
  }, {
    key: "updateSearchResults",
    value: function updateSearchResults(json) {
      var _json$results,
        _this3 = this;
      var searchResults = json === null || json === void 0 || (_json$results = json.results) === null || _json$results === void 0 ? void 0 : _json$results.map(function (result) {
        return _this3.updateLayerInfo(result);
      });
      this.updateState({
        loading: false,
        searchResults: searchResults || null,
        searchResultsVisible: true,
        selectedLayers: this.getSelectedLayers()
      });
    }
  }, {
    key: "getSelectedLayers",
    value: function getSelectedLayers() {
      return this.getSandbox().findAllSelectedMapLayers() || null;
    }
  }, {
    key: "updateLayerInfo",
    value: function updateLayerInfo(searchResult) {
      var _searchResult$uuid,
        _this4 = this;
      var layers = null;
      if (searchResult.id) {
        layers = this.mapLayerService.getLayersByMetadataId(searchResult.id);
      }
      if (searchResult !== null && searchResult !== void 0 && searchResult.uuid && searchResult !== null && searchResult !== void 0 && (_searchResult$uuid = searchResult.uuid) !== null && _searchResult$uuid !== void 0 && _searchResult$uuid.length) {
        searchResult.uuid.forEach(function (uuid) {
          var newLayers = _this4.mapLayerService.getLayersByMetadataId(uuid).filter(function (newLayer) {
            return !layers.find(function (oldLayer) {
              return oldLayer.id === newLayer.id;
            });
          });
          layers = layers.concat(newLayers);
        });
      }
      searchResult.layers = layers;
      return searchResult;
    }
  }, {
    key: "showMetadata",
    value: function showMetadata(uuid) {
      this.getSandbox().postRequestByName('catalogue.ShowMetadataRequest', [{
        uuid: uuid
      }]);
    }
  }, {
    key: "toggleCoverageArea",
    value: function toggleCoverageArea(result) {
      var _this$getState2 = this.getState(),
        displayedCoverageId = _this$getState2.displayedCoverageId;
      if (displayedCoverageId && displayedCoverageId === result.id) {
        this.coverageHelper.clearLayerCoverage();
        return;
      }
      this.coverageHelper.showMetadataCoverage(result.geom, result.id);
    }
  }, {
    key: "toggleLayerVisibility",
    value: function toggleLayerVisibility(checked, layerId) {
      var _this$getState3 = this.getState(),
        selectedLayers = _this$getState3.selectedLayers;
      var layerSelected = !!selectedLayers.find(function (layer) {
        return layer.getId() === layerId;
      });
      if (layerSelected) {
        this.instance.removeMapLayer(layerId);
      } else {
        this.instance.addMapLayer(layerId);
      }
    }
  }, {
    key: "updateSelectedLayers",
    value: function updateSelectedLayers() {
      this.updateState({
        selectedLayers: this.getSelectedLayers()
      });
    }
  }, {
    key: "updateDisplayedCoverageId",
    value: function updateDisplayedCoverageId(id) {
      this.updateState({
        displayedCoverageId: id
      });
    }

    /**
     * Advanced search
     */
  }, {
    key: "toggleAdvancedSearch",
    value: function toggleAdvancedSearch() {
      var _this$getState4 = this.getState(),
        advancedSearchExpanded = _this$getState4.advancedSearchExpanded;
      this.updateState({
        advancedSearchExpanded: !advancedSearchExpanded
      });
    }

    /**
     * Toggle from search results list back to search view
     */
  }, {
    key: "toggleSearch",
    value: function toggleSearch() {
      this.updateState({
        searchResultsVisible: false
      });
    }
  }, {
    key: "toggleSearchResultsFilter",
    value: function toggleSearchResultsFilter(value) {
      this.updateState({
        searchResultsFilter: value
      });
    }
  }, {
    key: "loadOptions",
    value: function loadOptions() {
      var _this$getState5 = this.getState(),
        advancedSearchOptions = _this$getState5.advancedSearchOptions;
      if (!advancedSearchOptions) {
        this.fetchOptions();
      }
    }
  }, {
    key: "fetchOptions",
    value: function () {
      var _fetchOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var fields, emptyOption;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.updateState({
                advancedSearchOptions: {
                  loading: true
                }
              });
              fields = [];
              emptyOption = Oskari.getMsg(METADATA_BUNDLE_LOCALIZATION_ID, 'advancedSearch.emptyOption');
              _context.next = 5;
              return this.optionsService.getOptions(function (options) {
                var _options$fields;
                options === null || options === void 0 || (_options$fields = options.fields) === null || _options$fields === void 0 || _options$fields.forEach(function (field) {
                  var sortedValues = field.values.sort(function (a, b) {
                    return Oskari.util.naturalSort(a.val, b.val);
                  }).map(function (_ref) {
                    var val = _ref.val;
                    return {
                      label: val,
                      value: val
                    };
                  });
                  if (!sortedValues.length) {
                    // don't store field with no values
                    return;
                  }
                  if (!field.multi) {
                    sortedValues.unshift({
                      label: emptyOption,
                      value: ''
                    });
                  }
                  fields.push(_objectSpread(_objectSpread({}, field), {}, {
                    values: sortedValues
                  }));
                });
              });
            case 5:
              this.updateState({
                advancedSearchOptions: {
                  fields: fields,
                  loading: false
                }
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOptions() {
        return _fetchOptions.apply(this, arguments);
      }
      return fetchOptions;
    }()
  }, {
    key: "advancedSearchParamsChanged",
    value: function advancedSearchParamsChanged(key, value) {
      this.updateState({
        advancedSearchValues: _objectSpread(_objectSpread({}, this.getState().advancedSearchValues), {}, _defineProperty({}, key, value))
      });
    }
  }, {
    key: "advancedSearchCoverageStartDrawing",
    value: function advancedSearchCoverageStartDrawing(evt) {
      this.updateState({
        drawing: true,
        coverageFeature: null
      });
      this.instance.startDrawing();
    }
  }, {
    key: "advancedSearchCoverageCancelDrawing",
    value: function advancedSearchCoverageCancelDrawing(evt) {
      this.updateCoverageFeature(null);
      this.instance.stopDrawing();
    }
  }, {
    key: "updateCoverageFeature",
    value: function updateCoverageFeature(coverageFeature) {
      var _this$getState6 = this.getState(),
        advancedSearchValues = _this$getState6.advancedSearchValues;
      advancedSearchValues.coverage = coverageFeature;
      this.updateState({
        drawing: false,
        advancedSearchValues: advancedSearchValues
      });
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(MetadataStateHandler, ['doSearch', 'showMetadata', 'toggleCoverageArea', 'updateQuery', 'renderMetadataSearch', 'toggleSearch', 'toggleAdvancedSearch', 'toggleSearchResultsFilter', 'advancedSearchParamsChanged', 'advancedSearchCoverageStartDrawing', 'advancedSearchCoverageCancelDrawing', 'updateCoverageFeature', 'toggleLayerVisibility', 'updateSelectedLayers', 'updateSearchResults', 'updateDisplayedCoverageId', 'handleMetadataSearchRequest']);
export { wrapped as MetadataStateHandler };